import { useTranslate } from '@/components/Helpers/Translate'

type Props = {
  isThereEnoughTimeToShip: boolean | null
}

export const TooCloseToShipDateAlert = ({ isThereEnoughTimeToShip }: Props) => {
  const { translate } = useTranslate()
  if (isThereEnoughTimeToShip) return null
  if (isThereEnoughTimeToShip === null) return null

  return (
    <div
      className="p-3 text-[#D03C3C]"
      dangerouslySetInnerHTML={{
        __html: translate('not_enough_time_to_ship_item'),
      }}
    />
  )
}
